/** @jsx h */
import { useRef, useEffect } from 'preact/hooks';
import { labels } from '../../config';
import {
  labels as mapLabels,
  lang,
} from '../../../../molecules/map/map-labels';
import { MapOSM } from '../../../../molecules/map/map-osm';

let mapInstance;

const Map = ({
  highlight,
  list,
  consent,
  lat,
  lon,
  isLoading,
  currentPage,
  itemsPerPage,
}) => {
  const container = useRef(null);
  const mapContainer = useRef(null);
  const mapDetail = useRef(null);
  const mapDetailContent = useRef(null);
  const mapDetailClose = useRef(null);
  const mapShowMore = useRef(null);

  function handleMarkerToggle() {
    if (mapShowMore.current) {
      const isChecked = mapShowMore.current.checked;

      if (isChecked) {
        // zoom to the first 10 entries
        consent &&
          mapInstance &&
          mapInstance.updateMarkers(
            [...highlight, ...list],
            lat,
            lon,
            [...highlight, ...list].slice(0, 10)
          );
      } else {
        consent &&
          mapInstance &&
          mapInstance.updateMarkers(highlight, lat, lon);
      }
    }
  }

  useEffect(() => {
    if (consent && mapContainer.current) {
      mapInstance = new MapOSM({
        container: container.current,
        mapContainer: mapContainer.current,
        mapDetail: mapDetail.current,
        mapDetailContent: mapDetailContent.current,
        mapDetailClose: mapDetailClose.current,
        mapFitBounds: true,
        mapData: list,
      });

      mapInstance.init();
      return;
    }

    mapInstance?.destroy();
  }, [consent]);

  useEffect(() => {
    if (highlight?.length) {
      consent && mapInstance && mapInstance.updateMarkers(highlight, lat, lon);
    } else {
      const resultList =
        lat && lon ? list.slice(0, currentPage * itemsPerPage) : list;

      consent && mapInstance && mapInstance.updateMarkers(resultList, lat, lon);
    }

    mapInstance.closeDetail();
  }, [list, currentPage]);

  return (
    <div className="map" ref={container}>
      <div className="skip-link">
        <a href="#skip-link-target-map" className="skip-link__link">
          <span>{labels.map.skip}</span>
        </a>
      </div>
      <div className="map__map">
        <div
          id="osm-cDATA-UID"
          className="map__osm"
          aria-label={labels.map.heading}
          ref={mapContainer}
        />
        <div
          className="map__detail"
          id="map-detail"
          role="dialog"
          aria-label="Standortdetails"
          aria-describedby="map-detail"
          ref={mapDetail}
        >
          <button
            className="map__detail-close"
            aria-controls="map-detail"
            ref={mapDetailClose}
          >
            <span className="map__detail-icon icon icon--cross">
              <svg className="icon__svg" role="img" aria-hidden="true">
                <use href="#icon-cross" />
              </svg>
              <span className="sr-only">{mapLabels.closeDetail[lang]}</span>
            </span>
          </button>
          <div
            id="map-detail"
            className="map__detail-content"
            ref={mapDetailContent}
          />
        </div>
        {highlight?.length ? (
          <div className="map__show-more input-filter--map">
            <input
              id="map__checkbox-show-more"
              className="input-filter__input sr-only"
              type="checkbox"
              ref={mapShowMore}
              onChange={handleMarkerToggle}
            />
            <label
              htmlFor="map__checkbox-show-more"
              className="input-filter__label"
            >
              <span className="input-filter__icon icon icon--check">
                <svg role="img" aria-hidden="true" className="icon__svg">
                  <use href="#icon-check" />
                </svg>
              </span>
              <span className="input-filter__label-text">
                {mapLabels.showMore[lang]}
              </span>
            </label>
          </div>
        ) : (
          ''
        )}
        <div className="map__controls">
          <button
            className="map__control map__zoom-in"
            aria-controls="osm-cDATA-UID"
          >
            <span className="map__icon icon icon--plus">
              <svg className="icon__svg" role="img" aria-hidden="true">
                <use href="#icon-plus" />
              </svg>
              <span className="sr-only">{mapLabels.zoomIn[lang]}</span>
            </span>
          </button>
          <button
            className="map__control map__zoom-out"
            aria-controls="osm-cDATA-UID"
          >
            <span className="map__icon icon icon--minus">
              <svg className="icon__svg" role="img" aria-hidden="true">
                <use href="#icon-minus" />
              </svg>

              <span className="sr-only">{mapLabels.zoomOut[lang]}</span>
            </span>
          </button>
        </div>
      </div>
      <div id="skip-link-target-map" tabIndex="-1" aria-hidden="true" />
    </div>
  );
};

export { Map };
